import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Button, Card, Col, Modal, Row} from "react-bootstrap";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
const AIPrediction = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState(null);
// ============================
// LOAD
// ============================
    const loadData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(baseUrl + "ai-prediction/");
            setData(res.data);
        } catch (error) {
            Swal.fire("Error", "Unable to load predictions", "error");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadData();
    }, []);
// ============================
// VIEW
// ============================
    const viewPrediction = (row) => {
        setSelected(row);
        setShow(true);
    };
// ============================
// SUMMARY
// ============================
    const total = data.length;
    const success = data.filter(x => x.status === "Success").length;
    const failed = data.filter(x => x.status === "Failed").length;
    const avgConfidence =
        data.length > 0
            ?
            (
                data.reduce((sum, x) =>
                        sum + Number(x.confidence_score || 0)
                    , 0) / data.length
            ).toFixed(2)
            :
            0;
    const columns = [
        {
            field: "id", headerName: "ID", width: 80
        },
        {
            field: "ai_model_name", headerName: "AI Model", flex: 1,
            valueGetter: (params) =>
                params.row.ai_model_name || params.row.ai_model?.model_name
        },
        {
            field: "confidence_score", headerName: "Confidence %", width: 150
        },
        {
            field: "status", headerName: "Status", width: 120
        },
        {
            field: "prediction_date", headerName: "Date", width: 180
        },
        {
            field: "action", headerName: "Action", width: 120,
            renderCell: (params) => (
                <Button

                    size="sm"

                    variant="info"

                    onClick={() => viewPrediction(params.row)}

                >

                    View

                </Button>
            )
        }
    ];
    return (
        <>


            <Row className="mb-3">


                <Col md={3}>

                    <Card className="shadow">

                        <Card.Body>

                            <h6>
                                Total Predictions
                            </h6>

                            <h3>
                                {total}
                            </h3>

                        </Card.Body>

                    </Card>

                </Col>


                <Col md={3}>

                    <Card className="shadow">

                        <Card.Body>

                            <h6>
                                Average Confidence
                            </h6>

                            <h3>
                                {avgConfidence} %
                            </h3>

                        </Card.Body>

                    </Card>

                </Col>


                <Col md={3}>

                    <Card className="shadow">

                        <Card.Body>

                            <h6>
                                Success
                            </h6>

                            <h3>
                                {success}
                            </h3>

                        </Card.Body>

                    </Card>

                </Col>


                <Col md={3}>

                    <Card className="shadow">

                        <Card.Body>

                            <h6>
                                Failed
                            </h6>

                            <h3>
                                {failed}
                            </h3>

                        </Card.Body>

                    </Card>

                </Col>


            </Row>


            <Card className="shadow">


                <Card.Header>

                    <h5>
                        AI Prediction Dashboard
                    </h5>


                </Card.Header>


                <Card.Body>


                    <div
                        style={{
                            height: 500, width: "100%"
                        }}
                    >


                        <ERPDataGrid

                            rows={data}

                            columns={columns}

                            loading={loading}


                        />


                    </div>


                </Card.Body>


            </Card>


            <Modal

                show={show}

                onHide={() => setShow(false)}

                size="lg"

            >


                <Modal.Header closeButton>

                    <Modal.Title>

                        Prediction Result

                    </Modal.Title>

                </Modal.Header>


                <Modal.Body>


                    <Row>


                        <Col md={6}>


                            <h6>
                                Input Data
                            </h6>


                            <pre>

{
    JSON.stringify(selected?.input_data,
        null,
        4)
}


</pre>


                        </Col>


                        <Col md={6}>


                            <h6>
                                Output Result
                            </h6>


                            <pre>


{
    JSON.stringify(selected?.output_result,
        null,
        4)
}


</pre>


                        </Col>


                    </Row>


                </Modal.Body>


                <Modal.Footer>


                    <Button

                        variant="secondary"

                        onClick={() => setShow(false)}

                    >

                        Close

                    </Button>


                </Modal.Footer>


            </Modal>


        </>
    );
};
export default AIPrediction;